export default {
	currentPage: '第 {page} 頁',
	edit: '編輯',
	editValue: '編輯 {value}',
	goToPage: '跳轉到 {page}',
	noResults: '0 項',
	pageOfTotal: '{page} / {totalPages} 頁。 共 {totalRows} 項',
	pageOfUnknownTotal: '{page} / ? 頁',
	pagination: '分頁導航',
	resultRange: '第 {from} 到 {to} 項，共 {total} 項',
	sortBy: '根據 {name} 排序',
	filterBy: '根據 {name} 篩選'
};
